import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { compareAsc, format } from "date-fns";
import moment from "moment";
import jwt_decode from "jwt-decode";
import Skills from "./Skills/Skills";
import { getPermissions, set_user_info } from "../../Redux/Actions/login_actions"
function ProfileCom() {
  const dispatch = useDispatch();
  const get_oermission_data = useSelector((state) => state);
  const user_info = get_oermission_data.login_Permission.user_data;
  const user_img = user_info?.img ? user_info?.img : user_info?.gender == 1 ? 'm_user.png' : 'f_user.png';

  const RMGF = user_info?.RMGF ? user_info?.RMGF : '';
  const RMGM = user_info?.RMGM ? user_info?.RMGM : '';
  const RMGL = user_info?.RMGL ? user_info?.RMGL : '';
  const userFname = user_info?.fname ? user_info?.fname : '';
  const userMname = user_info?.mname ? user_info?.mname : '';
  const userLname = user_info?.lname ? user_info?.lname : '';
  const salutation = user_info?.salutation ? user_info?.salutation : '';

  // console.log('header_permission------------------header_permission')
  // console.log(user_info)
  // console.log('header_permission------------------header_permission')



  const [gender, setGender] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [dateofjoining, setDateofjoining] = useState("");
  const [marriage, setMarriage] = useState("");
  const [bloodgroup, setBloodgroup] = useState("");
  const [nationality, setNationality] = useState("");
  const [adhaarname, setAdhaarname] = useState("");
  const [adhaarnumber, setAdhaarnumber] = useState("");
  const [pancardnumber, setPancardnumber] = useState("");
  const [empstatus, setEmpstatus] = useState();
  const [contactnumber, setContactnumber] = useState();
  const [email, setEmail] = useState();
  const [emailpersonal, setEmailpersonal] = useState();
  const [empcode, setEmpcode] = useState("");
  const [userrole, setUserrole] = useState("");
  const [userdept, setUserdept] = useState(user_info.dept_name);
  const [role, setRole] = useState();
  const [division, setDivision] = useState("");
  const [company, setCompany] = useState("");
  const [probation_period, setProbation_period] = useState("");
  const [confirmationdate, setConfirmationdate] = useState("");
  const [pincode, setPincode] = useState("");
  const [department, setDepartment] = useState(user_info.role);

  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));
  const [userId, setUserId] = useState(localStorage.getItem('userId'))
  const [picture, setPicture] = useState(null);
  const HandleProfileImg = async (e) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      const formdata = new FormData();
      formdata.append('user_id', userId);
      formdata.append('userImage', e.target.files[0]);
      upload_User_Image(formdata)
    }

  }
  function upload_User_Image(formdata) {
    const response = fetch(SERVER_URL + `api/employee/user-image-update`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'authorization': `bearer ${token.value}`
        },
        body: formdata,
      }).then(res => res.json())
      .then(data => {
        if (data.status == true) {
          dispatch(set_user_info())
        }
      })
  }
  return (
    <div className="container-fluid">
      <div className="dash_ttl">Profile</div>
      <div className="crumbs">
        <ul id="breadcrumbs" className="breadcrumb">
          <li>
            <a href="#">Dashboard </a>
          </li>
          <li className="current">
            <span>/</span>Profile
          </li>
        </ul>
      </div>
      <div className="profile_detail_wrp">
        <div className="row">
          <div className="col-md-3">
            <div className="profile_detail">
              <div className="profile_img_wrp">
                <div className="pro_img profile_upload_wrp">
                  <img src={`${SERVER_URL + "userimages/" + user_img}`} alt="" />
                  <div className="buttonwrap">
                    <label className="button_upload" htmlFor="upload">
                      <i className="fa fa-camera"></i>
                    </label>
                    <input id="upload" type="file" onChange={HandleProfileImg} />
                  </div>
                </div>
                <div className="pro_detail">
                  <div class="pro_detail">
                    <div class="pro_title"> {userFname + ' ' + userMname + ' ' + userLname}</div>
                    <div class="pro_sub_head"> {user_info?.role_name ? user_info.role_name : ""}</div>
                    <div class="pro_sub_head"><i class="icon icon-apartment"></i>{user_info?.dept_name ? user_info.dept_name : ""}</div>
                  </div>
                </div>
              </div>
              <div className="pro_wrp">
                <div className="pro_blk">
                  <div className="pro_heading">Phone Number</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-telephone2 mr08"></i>
                    {user_info?.contact ? user_info?.contact : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Email</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-envelope mr08"></i>
                    {user_info?.email ? user_info?.email : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Date of Birth</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-cake mr08"></i>
                    {user_info?.birth ? moment(user_info?.birth).format("DD, MMM YYYY") : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Date of Joining</div>
                  <div className="pro_sub_head">
                    <i className="icon icon-calendar-full mr08"></i>
                    {user_info?.dateOfJoining ? moment(user_info?.dateOfJoining).format("DD, MMM YYYY") : ""}
                  </div>
                </div>
                <div className="pro_blk">
                  <div className="pro_heading">Reporting Manager</div>
                  <div className="pro_sub_head">{RMGF ? RMGF : ''} {RMGM ? RMGM : ''} {RMGL ? RMGL : ''}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9 relative">
            <div
              className="nav"
              id="profiletab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                className="nav-link active"
                id="personal-tab"
                data-bs-toggle="tab"
                href="#personal"
                data-bs-target="#personal"
              >
                Personal Profile
              </a>

              <a
                className="nav-link"
                id="contact-tab"
                data-bs-toggle="tab"
                href="#contact"
                data-bs-target="#contact"
              >
                Contact Details
              </a>

              <a
                className="nav-link"
                id="official-tab"
                data-bs-toggle="tab"
                href="#official"
                data-bs-target="#official"
              >
                Official
              </a>
              <a
                className="nav-link"
                id="skills-tab"
                data-bs-toggle="tab"
                href="#skills"
                data-bs-target="#skills"
              >
                Skills
              </a>
            </div>
            <div className="tab-content" id="profiletabContent">
              <div
                className="tab-pane fade active show"
                id="personal"
                role="tabpanel"
                aria-labelledby="personal-tab"
              >
                <div className="row mb30">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Salutation</div>
                      <div className="form-input fw-500">
                        {salutation
                          ? salutation == 1
                            ? "Mr"
                            : salutation == 2
                              ? "Ms"
                              : salutation == 3
                                ? ""
                                : "Mrs"
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">FIRST NAME</div>
                      <div className="form-input fw-500">{userFname ? userFname : ""}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Middle Name</div>
                      <div className="form-input fw-500">{userMname ? userMname : ""}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Last Name</div>
                      <div className="form-input fw-500">{userLname ? userLname : ""}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Father/Husband Name</div>
                      <div className="form-input fw-500">
                        {user_info.guardian_name ? user_info.guardian_name : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Gender</div>
                      <div className="form-input fw-500">
                        {user_info.gender ? (user_info.gender == 1 ? "Male" : "Female") : user_info.gender == null ? 'N/A' : ''}
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Date Of Birth</div>
                      <div className="form-input fw-500">
                        {moment(dateofbirth ? dateofbirth : "").format(
                          "DD MMM, yyyy"
                        )}
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Marital Status</div>
                      <div className="form-input fw-500">Married</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Blood group</div>
                      <div className="form-input fw-500">
                        {user_info.blood_group ? user_info.blood_group : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Nationality</div>
                      <div className="form-input fw-500">
                        {user_info.nationality_type ? user_info.nationality_type : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Wedding anniversary</div>
                      <div className="form-input fw-500">{user_info.wedding_day ? moment(user_info.wedding_day).format("DD, MMM YYYY") == 'Invalid date' ? 'N/A' : moment(user_info.wedding_day).format("DD, MMM YYYY") : ''}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Aadhaar Card Number</div>
                      <div className="form-input fw-500">
                        {user_info.uid_no ? user_info.uid_no : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Aadhaar Card Name</div>
                      <div className="form-input fw-500">
                        {user_info.uid_name ? user_info.uid_name : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Pan Card Number</div>
                      <div className="form-input fw-500">
                        {user_info.pan_no ? user_info.pan_no : "N/A"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Status</div>
                      <div className="form-input fw-500">
                        {user_info.status
                          ? user_info.status == 1
                            ? "Active"
                            : "Inactive"
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- <div className=" text-end">
                                    <button className="btn_5">Edit</button>
                                </div> --> */}
              </div>

              <div
                className="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <div className="tab_sub_ttl">Current Address</div>
                <div className="row mb10">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Address</div>
                      <div className="form-input">N/A</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">City</div>
                      <div className="form-input">{user_info.city ? user_info.city : 'N/A'}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">State</div>
                      <div className="form-input">{user_info.state ? user_info.state : 'N/A'}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Pin Code</div>
                      <div className="form-input">{user_info.zipcode ? user_info.zipcode : "N/A"}</div>
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Mobile #</div>
                      <div className="form-input">
                        {contactnumber ? contactnumber : "N/A"}
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Email Personal</div>
                      <div className="form-input">
                        {user_info.personal_email ? user_info.personal_email : "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab_sub_ttl">Emergency Contact</div>
                <div className="row mb30">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Name</div>
                      <div className="form-input">N/A</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Relationship</div>
                      <div className="form-input"></div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Mobile #</div>
                      <div className="form-input"></div>
                    </div>
                  </div>
                </div>

                {/* <div className=" text-end">
                  <button className="btn_5">Edit</button>
                </div> */}
              </div>

              <div
                className="tab-pane fade"
                id="official"
                role="tabpanel"
                aria-labelledby="official-tab"
              >
                <div className="tab_sub_ttl">Organization</div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Company</div>
                      <div className="form-input">
                        {user_info.comp_id
                          ? user_info.comp_id == 1
                            ? "Q2A Media Services Pvt Ltd"
                            : user_info.comp_id == 2
                              ? "Q2A Services Pvt Ltd"
                              : user_info.comp_id == 3
                                ? "Bill Smith Group Inc"
                                : ""
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Division</div>
                      <div className="form-input">
                        {user_info.division
                          ? user_info.division == 1
                            ? "Q2A Media Services Pvt Ltd"
                            : user_info.division == 2
                              ? "Q2A Services Pvt Ltd"
                              : user_info.division == 3
                                ? "Bill Smith Group Inc"
                                : ""
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Department</div>
                      <div className="form-input">{user_info.department ? user_info.department : 'N/A'}</div>
                    </div>
                  </div>
                </div>

                <div className="tab_sub_ttl">Employee Details</div>
                <div className="row mb25">
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Employee Code</div>
                      <div className="form-input">{user_info.user_code ? user_info.user_code : ""}</div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Employee Status</div>
                      <div className="form-input">{user_info.user_type ? user_info.user_type : 'N/A'}</div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Date of joining</div>
                      <div className="form-input">
                        {/* {dateofjoining?dateofjoining.format('MMM-DD-YYYY'):''} */}
                        {user_info.joining_date ? moment(user_info.joining_date).format("DD, MMM YYYY") : 'N/A'}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Probation Period (Months)</div>
                      <div className="form-input">
                        {user_info.probation_period ? user_info.probation_period : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Confirmation Date</div>
                      <div className="form-input">
                        {confirmationdate ? confirmationdate : ""}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Designation </div>
                      <div className="form-input">
                        {user_info.role_name ? user_info.role_name : "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Notice Period (Days) </div>
                      <div className="form-input">30 Days</div>
                    </div>
                  </div>

                </div>
                {/* <div className=" text-end">
                  <button className="btn_5">Edit</button>
                </div> */}
              </div>

              <Skills department={userdept} page_action={'view'} department_id={department}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileCom;